import React, { lazy, Suspense, useMemo, useState } from 'react';
import { listingMapPoints } from '../utils/listingMapData';
import { pointInZone } from '../utils/listingZone';
import { useTranslation } from 'react-i18next';
import { LuList, LuMap } from 'react-icons/lu';
import './ListingMap.css';

const ListingMap = lazy(() => import('./ListingMap'));

class MapBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() { return this.state.failed ? <p role="alert">{this.props.message}</p> : this.props.children; }
}

export default function ListingResultsView({ listings, kind = 'bien', Card, mode, onModeChange, children }) {
  const { t } = useTranslation();
  const [zone, setZone] = useState(null);
  const filtered = useMemo(() => zone ? listingMapPoints(listings).filter(p => pointInZone([p.position[1], p.position[0]], zone)).map(p => p.listing) : listings, [listings, zone]);
  return <div className="min-w-0">
    <div role="group" aria-label={t('mapView.display')} className="lina-results-toggle">
      {['list', 'map'].map(value => <button key={value} type="button" aria-pressed={mode === value}
        onClick={() => onModeChange(value)}
        >
        {value === 'list' ? <LuList aria-hidden="true" /> : <LuMap aria-hidden="true" />}
        {t(`mapView.${value}`)}
      </button>)}
    </div>
    {zone && <div className="mb-3"><p>{t('mapZone.loaded', { count: filtered.length })}</p><button type="button" className="rounded-xl border p-3" onClick={() => setZone(null)}>{t('mapZone.clear')}</button></div>}
    {mode === 'list' ? <>{zone && !filtered.length && <p role="status">{t('mapZone.empty')}</p>}{typeof children === 'function' ? children(filtered) : children}</> : <MapBoundary message={t('mapView.unavailable')}>
      <Suspense fallback={<p role="status" className="p-6">{t('mapView.loading')}</p>}>
        <ListingMap listings={listings} kind={kind} Card={Card} zone={zone} onZoneChange={setZone} />
      </Suspense>
    </MapBoundary>}
  </div>;
}
